/**
 * booking@v2 (`booking:/v1/book@v2`, commercial-contract §6.15) prices a reservation
 * from the quote it parked for the offer + stay. A quote that lapsed (or never existed
 * for that stay) is refused with 409 `offer_expired` — nothing was booked and the
 * Idempotency-Key is not burned. The operator searches again; the console never
 * re-searches silently.
 *
 * Its own module (not `api.ts`) so screens can recognise it even where a test mocks the
 * booking client wholesale.
 */
export class OfferExpiredError extends Error {
  constructor(readonly offerUrn: string | null) {
    super('offer_expired');
    this.name = 'OfferExpiredError';
  }
}
